import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkMath from 'remark-math';
import remarkGfm from 'remark-gfm';
import remarkDirective from 'remark-directive';
import rehypeKatex from 'rehype-katex';
import 'katex/dist/katex.min.css';
import {
  normalizeMathBlockDelimiters,
  remarkAudioEmbeds,
  remarkExpandableBlocks,
  remarkYouTubeEmbeds,
} from '../../utils/markdown';

type MarkdownContentProps = {
  content: string;
};

const MarkdownContent: React.FC<MarkdownContentProps> = ({ content }) => {
  return (
    <div className="markdown-content">
      <ReactMarkdown
        remarkPlugins={[
          remarkMath,
          remarkGfm,
          remarkDirective,
          remarkExpandableBlocks,
          remarkYouTubeEmbeds,
          remarkAudioEmbeds,
        ]}
        rehypePlugins={[rehypeKatex]}
      >
        {normalizeMathBlockDelimiters(content)}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownContent;
